import React from 'react';
import Loadable from 'react-loadable';
import styled from 'styled-components';
import Spinner from '../Spinner/Spinner';

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #2563eb;
`;

const LazyPage = (loader) =>
  Loadable({
    loader,
    loading: () => (
      <Wrapper>
        <Spinner />
      </Wrapper>
    )
  });

export default LazyPage;
